import { useEffect } from 'react';

import { useRecoilState } from 'recoil';
import { useQuery } from 'react-query';
import styled from 'styled-components';

import { API_URL } from 'api/API';
import getServerTimeApi from 'api/skyw/getServerTimeApi';

import { dateTimeState } from 'libs/atoms';
import { convertDateTime } from 'libs/utils';
import { MEDIA_SIZE_LIST } from 'libs/const';

const Wrapper = styled.div`
  display: flex;
  gap: 8px;
  font-size: 18px;
  font-weight: 500;

  @media screen and (max-width: ${`${MEDIA_SIZE_LIST[1]}px`}) {
    font-size: 14px;
  }
`;

const SDate = styled.span`
  color: ${(props) => props.theme.skyw.grayTextColor};
`;

const STime = styled.span`
  color: ${(props) => props.theme.skyw.mainColor2};
`;

interface ClockProps {
  obsId: number;
}

const Clock = ({ obsId }: ClockProps) => {
  const [dateTime, setDateTime] = useRecoilState(dateTimeState);
  const { data } = useQuery([API_URL.SKYW.GET_SERVER_TIME, obsId], () => getServerTimeApi({ obsId }), {
    refetchInterval: 1000 * 30,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: true,
  });

  useEffect(() => {
    if (!data?.date || !data?.time) return;
    const date = new Date(`${data.date.replaceAll('-', '/')} ${data.time}`);

    function updateDateTime(add: 0 | 1) {
      date.setSeconds(date.getSeconds() + add);

      const newDateTime = convertDateTime(date);

      setDateTime({
        obsId,
        date: newDateTime.date,
        time: newDateTime.time,
      });
    }

    updateDateTime(0);

    const interval = setInterval(() => {
      updateDateTime(1);
    }, 1000);

    return () => clearInterval(interval);
  }, [data, obsId, setDateTime]);

  if (!dateTime?.date || !dateTime?.time || dateTime?.obsId !== obsId) {
    return null;
  }

  return (
    <Wrapper>
      <SDate>{dateTime.date.replaceAll('-', '.')},</SDate>
      <STime>{dateTime.time}</STime>
    </Wrapper>
  );
};

export default Clock;
